import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueGtag from "vue-gtag";
import Vuetify from 'vuetify';
import App from './App.vue';
import router from './router';
import store from '@/store';
import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import VueEvents from 'vue-events';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import ECharts from 'vue-echarts';
import { library } from '@fortawesome/fontawesome-svg-core';
// import * as faicons from '@fortawesome/free-solid-svg-icons';
import { faBriefcase, faCalendar, faSearch, faEnvelope, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueSweetalert2 from 'vue-sweetalert2';
import Vuelidate from 'vuelidate';
import VueDateFns from 'vue-date-fns';
import draggable from 'vuedraggable';
import DatetimePicker from 'vuetify-datetime-picker';
import 'vuetify-datetime-picker/src/stylus/main.styl';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VCreditCard from 'v-credit-card';
import VueTour from 'vue-tour';

require('vue-tour/dist/vue-tour.css');

Sentry.init({
  debug: true,
  dsn: 'https://3a902b95cb4d422389a834632d2bfbbf@sentry.strategenics.com.au/27',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  beforeSend(event) {
    console.log(event);
    return null;
  },
});

library.add(faBriefcase);
library.add(faCalendar);
library.add(faSearch);
library.add(faEnvelope);
library.add(faQuestionCircle);

Vue.prototype.$log = console.log.bind(console);

Vue.config.productionTip = false;

const swalOptions = {
  confirmButtonColor: '#B4B4B4',
  confirmButtonClass: 'v-btn v-btn--depressed v-btn--round theme--light',
}

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_G_MEASUREMENT_ID }
  }, router);
}

Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(VueSweetalert2, swalOptions);
Vue.use(VueEvents);
Vue.use(Vuelidate);
Vue.use(VueDateFns);
Vue.use(DatetimePicker);
Vue.use(draggable);
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    key: 'AIzaSyDvErfjIlnf2EERzvnFyNzP1M8O6Tdejkg',
    // Enable more Google Maps libraries here
    libraries: ['places'],
    // Use new renderer
    useBetaRenderer: false,
  },
});
Vue.use(VueTour as any);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-chart', ECharts);
Vue.component('GmapCluster', GmapCluster);
Vue.component('v-credit-card', VCreditCard);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
